var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('color-picker',{on:{"change":_vm.headleChangeColor},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }